import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import { ELocale } from "../types/locale";

// Language translation files
import english from "./locales/en.json";
import spanish from "./locales/es.json";
import catalan from "./locales/ca.json";
import swedish from "./locales/sv.json";
import swahili from "./locales/sw.json";

const resources = {
  "en-US": { translation: english },
  "es-ES": { translation: spanish },
  ca: { translation: catalan },
  "sv-SE": { translation: swedish },
  sw: { translation: swahili },
};

const defaultLanguage = ELocale.EN;
const storedLanguage = localStorage.getItem("locale") || defaultLanguage;
const prodMode = import.meta.env.VITE_PROD_MODE;
const debugMode = prodMode === "false" ? true : false;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: storedLanguage,
    fallbackLng: defaultLanguage,
    debug: debugMode,
    resources: resources,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
